import { useState, useEffect, useCallback } from "react";

import API from "utils/api";
import { useUser } from "utils/hooks";

export default function usePlaylist(id, filters) {
  const { token } = useUser();
  const [result, setResult] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchPlaylist = useCallback(async () => {
    setLoading(true);

    try {
      const { response, data } = await API.fetchPlaylist(token, id, filters);

      if (response.ok) {
        setResult(data);
        setError(null);
      } else {
        setError({ status: response.status, ...data });
      }
    } finally {
      setLoading(false);
    }
  })

  useEffect(() => {
    if (id) fetchPlaylist();
  }, [id, filters]);

  return {
    loading,
    error,
    refresh: fetchPlaylist,
    playlist: result?.playlist,
    results: result?.results,
    page: result?.page ?? 0,
    count: result?.count ?? 0,
    limit: result?.limit ?? 32,
  };
}
